import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Load Google Tag Manager only after first user interaction or 5s idle (~59 KiB not parsed on initial load)
function loadGTM() {
  if (window.__GTM_LOADED__) return;
  window.__GTM_LOADED__ = true;

  // GA4 Measurement ID (à définir dans l'environnement).
  // Exemple: REACT_APP_GA4_MEASUREMENT_ID=G-P75LCTTGYZ
  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID || "G-P75LCTTGYZ";

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId);
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s);
}
function scheduleGTM() {
  ['click', 'scroll', 'keydown', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function run() {
      document.removeEventListener(ev, run);
      loadGTM();
    }, { once: true, passive: true });
  });
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(function () { loadGTM(); }, { timeout: 5000 });
  } else {
    setTimeout(loadGTM, 5000);
  }
}
scheduleGTM();
// Pour GA4 (SPA), on veut que GTM soit chargé assez tôt même si l'utilisateur
// scanne le QR sans faire de click/scroll/keydown préalable.
setTimeout(loadGTM, 1000);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
